import { Http } from '../../common/api';
import { SitecoreLayoutApiConfiguration } from '../models/sitecore-layout-api-configuration';

export const sitecoreLayoutHttp = new Http();

export const initializeSitecoreLayoutApiHttp = (config: SitecoreLayoutApiConfiguration): void => {
  sitecoreLayoutHttp.initializeHttp(
    `${config.baseUrl}/sitecore/api/layout/placeholder/jss`,
    {},
    '',
    {
      sc_apikey: config.apiKey || '',
      tracking: false,
      sc_site: 'njord-store',
    }
  );
};
